import { render, staticRenderFns } from "./GruposAlerta.vue?vue&type=template&id=6f28dd0b&scoped=true&lang=pug"
import script from "./GruposAlerta.vue?vue&type=script&lang=js"
export * from "./GruposAlerta.vue?vue&type=script&lang=js"
import style0 from "./GruposAlerta.vue?vue&type=style&index=0&id=6f28dd0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28dd0b",
  null
  
)

export default component.exports